var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus128022(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:#fff;}.cls-2,.cls-3,.cls-5,.cls-6{fill:none;}.cls-2,.cls-3,.cls-4{stroke:#6e6e6e;}.cls-2,.cls-4,.cls-5{stroke-linecap:round;stroke-linejoin:round;}.cls-2,.cls-3,.cls-4,.cls-5{stroke-width:1.25px;}.cls-3{stroke-miterlimit:10;}.cls-5{stroke:#ff6a10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 128,
    height: 128
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 128,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.33,85c.44,14.55,4,19,14.4,19v3.85H42.27V104c10.35,0,14-4.44,14.4-19"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 10.45,
    y: 13.93,
    width: 107.09,
    height: 70.94,
    rx: 3.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 10.45,
    y1: 20.93,
    x2: 117.55,
    y2: 20.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 10.45,
    y1: 74.93,
    x2: 117.55,
    y2: 74.93
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "67.5 54.14 51.22 49 56.52 65.23 59.82 61.9 66.13 68.14 70.51 63.71 64.21 57.47 67.5 54.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 63.2,
    y1: 39.65,
    x2: 94.22,
    y2: 39.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 63.2,
    y1: 47.65,
    x2: 94.22,
    y2: 47.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 66.22,
    y1: 55.65,
    x2: 94.22,
    y2: 55.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M43.86,52.14s-2-2-3.88-4.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M43.86,52.14S47,48.42,50,44.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "54.22 59.44 33.78 59.44 33.78 37 56.22 37 56.22 50.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.76,118c-5.74,4.18-9.71.83-13.38-4.21s-5.61-9.87.1-14c4.75-3.46,8.33-1.72,11.51,1.87.64.72,1.26,1.51,1.87,2.35C113.52,109,115.5,113.85,109.76,118Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 94.52,
    y1: 110.81,
    x2: 107.63,
    y2: 101.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 100.9,
    y1: 105.87,
    x2: 96.46,
    y2: 99.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 128,
    height: 128
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus128022);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_128_022.aebea8b6e8bf48558429932df8114f56.svg";
export { ForwardRef as ReactComponent };